
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('linearGradient',{attrs:{"id":"PTsiEfj2THKtO9xz06mlla","x1":"24","x2":"24","y1":"5","y2":"43","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#21ad64"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#088242"}})]),_c('path',{attrs:{"fill":"url(#PTsiEfj2THKtO9xz06mlla)","d":"M39 16v25a2 2 0 01-2 2H11a2 2 0 01-2-2V7a2 2 0 012-2h17l11 11z"}}),_c('path',{attrs:{"fill":"#61e3a7","d":"M28 5v9a2 2 0 002 2h9L28 5z"}}),_c('path',{attrs:{"fill":"#107c42","d":"M39 16h-9c-.473 0-.917-.168-1.257-.444L39 27V16z"}}),_c('path',{attrs:{"fill":"#fff","d":"M32 23H16a1 1 0 00-1 1v12a1 1 0 001 1h16a1 1 0 001-1V24a1 1 0 00-1-1zm-15 6h4v2h-4v-2zm6 0h8v2h-8v-2zm8-2h-8v-2h8v2zm-10-2v2h-4v-2h4zm-4 8h4v2h-4v-2zm6 2v-2h8v2h-8z"}}),_c('path',{attrs:{"d":"M32 22.5c.827 0 1.5.673 1.5 1.5v12c0 .827-.673 1.5-1.5 1.5H16c-.827 0-1.5-.673-1.5-1.5V24c0-.827.673-1.5 1.5-1.5h16m0-.5H16c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V24c0-1.103-.897-2-2-2z","opacity":".05"}}),_c('path',{attrs:{"d":"M32 23a1 1 0 011 1v12a1 1 0 01-1 1H16a1 1 0 01-1-1V24a1 1 0 011-1h16m0-.5H16c-.827 0-1.5.673-1.5 1.5v12c0 .827.673 1.5 1.5 1.5h16c.827 0 1.5-.673 1.5-1.5V24c0-.827-.673-1.5-1.5-1.5z","opacity":".07"}})])
          )
        }
      }
    